import React from "react";
import PropTypes from 'prop-types';
import { Password, useFormValidation } from "../../index";

export const PasswordWithValidation = ({
    customValidation,
    errorMsg = "Enter a valid password",
    hintMsg,
    name,
    onBlur = () => { },
    onChange = () => { },
    onKeyUp = () => { },
    pattern,
    required = false,
    ...props
}) => {
    const passwordPattern = ''; // /^(?!(\d)\(\1{3}\))(?!(\d)\2{9})(?!(\d)\3{2}.\3{3}.\3{4})(?:\(^[2-9]\d{2}\)|^[2-9]\d{2})(.?)?\d{3}\4\d{4}$/;

    const validationRules = {
        [name]: {
            required: {
                value: required,
                message: errorMsg
            },
            pattern: {
                value: pattern ? pattern : passwordPattern,
                message: errorMsg
            },
            custom: {
                isValid: customValidation,
                message: errorMsg
            }
        }
    };

    const { handleInput, formErrors } = useFormValidation({ validations: validationRules });

    const handleChange = (event) => {
        const value = event.target.value;
        handleInput(event);
        onChange(event, value, formErrors[name]?.value);
    }

    const handleBlur = (event) => {
        const value = event.target.value;
        handleInput(event);
        onBlur(event, value, formErrors[name]?.value);
    }

    const handleKeyUp = (event) => {
        const value = event.target.value;
        handleInput(event);
        onKeyUp(event, value, formErrors[name]?.value);
    }

    return (
        <Password
            {...props}
            label={'Password'}
            error={formErrors[name]?.value}
            hintMsg={formErrors[name]?.message ? formErrors[name]?.message : hintMsg}
            name={name}
            onBlur={handleBlur}
            onChange={handleChange}
            onKeyUp={handleKeyUp}
            required={required}
        />
    )
}

PasswordWithValidation.propTypes = {
    customValidation: PropTypes.func,
    errorMsg: PropTypes.string,
    hintMsg: PropTypes.string,
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onKeyUp: PropTypes.func,
    pattern: PropTypes.string,
    required: PropTypes.bool,
}